import { useEffect, useRef } from 'react';

// usePolling — setInterval wrapper that replaces Supabase Realtime
// .channel().on('postgres_changes', ...).subscribe() blocks across the app.
// The internal tool has ~5 users, so 2s polling is plenty responsive and
// avoids the overhead of self-hosting Realtime or switching to AppSync.
//
// Accepts a single callback or an array. Callback identities are kept in a
// ref so you can pass freshly-created closures each render without tearing
// down the interval.
export function usePolling(fnOrFns, intervalMs = 2000) {
  const cbsRef = useRef();
  cbsRef.current = Array.isArray(fnOrFns) ? fnOrFns : [fnOrFns];

  useEffect(() => {
    const tick = () => {
      for (const cb of cbsRef.current || []) {
        try { cb?.(); } catch { /* swallow — one bad callback shouldn't kill the tick */ }
      }
    };
    const id = setInterval(tick, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
}
